<template>
  <v-dialog v-model="dialog" width="500">
    <template v-slot:activator="{ on, attrs }">
      <v-btn color="pink" x-small v-bind="attrs" v-on="on" dark fab>
        <v-icon small="small">mdi-list-box-outline</v-icon>
      </v-btn>
      <!-- <v-btn color="red lighten-2" dark v-bind="attrs" v-on="on">
        mdi-list-box-outline
      </v-btn> -->
    </template>

    <v-card>
      <v-card-title class="text-h5 grey lighten-2">
        Payment On File
      </v-card-title>
      
      <v-card-text v-if="selectedMerchant">

        <!-- <v-select class="mt-5" dense outlined :items="MerchantAccount" v-model="selectedMerchant" return-object
              item-text="name" label="Card Copy to"></v-select> -->

              
        <v-list dense v-if="!isLoading">
          <template v-for="(card, index) in cards">
            <v-list-item :key="index">
              <!-- <v-list-item-avatar @click="deleteCard(card)" class="pointer">
                        <v-icon class="grey lighten-1" dark>
                          mdi-delete
                        </v-icon>
                      </v-list-item-avatar> -->
              <!-- <v-list-item-avatar>
                        <v-btn x-small color="success"><v-icon small>delete</v-icon></v-btn>
                      </v-list-item-avatar> -->

              <v-list-item-content>
                <v-list-item-title>
                  <span v-if="card.metadata.deCard.name" class="text-capitalize">{{ card.metadata.deCard.name
                    }}</span><span v-if="card.account_type">{{
                      card.account_type }}</span> - <span v-if='card.metadata.deCard.number'>{{ card.metadata.deCard.number.slice(-4) }}</span> <span v-else>{{ card.metadata.deCard.account_number.slice(-4)}}</span> <span
                    class="text-capitalize">- {{
                      card.metadata.paymentType }}</span>
                </v-list-item-title>
                <v-list-item-subtitle><span v-if="card.metadata.deCard.exp_month">{{ card.metadata.deCard.exp_month
                    }}/{{
                      card.metadata.deCard.exp_year
                    }} - </span> <span>{{ card.updatedAt | moment("L LT")
                    }}</span></v-list-item-subtitle>
              </v-list-item-content>
              <!-- <v-list-item-action-text v-if="stripeCustomer.default_source === card.id">
                        <v-chip color="blue lighten-2" small>Default</v-chip>
                      </v-list-item-action-text> -->
              <v-list-item-action>
                <v-btn color="success" @click="useThis(card)">Use This</v-btn>
              </v-list-item-action>
            </v-list-item>
          </template>
        </v-list>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="close()">
          Close
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import SecretManagerService from "@/modules/SecretManager/service.js";
const encryptor = require("simple-encryptor")(process.env.VUE_APP_KEY);
import payCompassService from "@/modules/PayCompass/service.js";
// import donationCategoryService from "@/modules/DonationCategory/service.js";

export default {
  props: {
    id: {
      default: null,
    },
    selectedMerchant: {
      default: null
    },
    type: {
      default: 'customer',
    },
  },
  data() {
    return {
      // selectedMerchant: null,
      // MerchantAccount: [],
      isLoading: true,
      dialog: false,
      cards: null,
    }
  },
  watch: {
    dialog(val) {
      if (val) {
        // this.merchantServiceList()
        if (this.type === 'customer') {
          this.getCardSecretCustomer()
        } else {
          this.getCardSecretDonor()
        }
        // if (this.type === 'customer') {
        //   this.getCardSecret()
        // }
      }
    }
  },
  methods: {
    close() {
      this.dialog = false
    },
    // merchantServiceList() {
    //   return donationCategoryService.getAll().then((response) => {
    //     // this.loading = false;
    //     console.log('response merchant', response)
    //     this.MerchantAccount = response.data;
    //     this.selectedMerchant = this.MerchantAccount[1]
    //     // this.itemsPerPage = this.merchants.length
    //   });
    // },
    useThis(data) {
      console.log('card', data)
      data.metadata.userSecret = true
      data.metadata.donationCategoryId = this.selectedMerchant.id
      delete data.metadata.deCard
      payCompassService.addCard(data.metadata).then(() => {
        ///console.log('add card response working', response)
        // this.dialog = !this.dialog
        // this.cardCollected = true;
        // this.reset()
        this.$router.go()


      }).catch(error => {
        this.loading = false;
        this.dialog = false
        console.log("error adding card2", error);
        this.$swal("Payment!", error.data.message, "error");
      })
    },
    getCardSecretDonor() {
      console.log('i got call donor')

      SecretManagerService.getDonorById(this.id).then(response => {

        const cards = response.data
        cards.map(row => {
          console.log('row', row)
          if (row.metadata) {
            // row.metadata.card = JSON.parse(encryptor.decrypt(row.metadata.card));
            row.metadata.deCard = JSON.parse(encryptor.decrypt(row.metadata.card));
          } else {
            row.metadata = {};
            row.metadata.card = row.card
            row.metadata.deCard = JSON.parse(encryptor.decrypt(row.card));
          }

          // if (!row.metadata.deCardnumber)

        })
        this.cards = cards
        // this.isLoading = false
        console.log('card getSecretById', this.cards)
        this.isLoading = false
      }).catch(error => {
        console.log('error', error)
        this.isLoading = false
      })
    },
    getCardSecretCustomer() {
      console.log('i got call customer')

      SecretManagerService.getCustomerById(this.id).then(response => {

        const cards = response.data
        cards.map(row => {
          console.log('row', row)
          if (row.metadata) {
            // row.metadata.card = JSON.parse(encryptor.decrypt(row.metadata.card));
            row.metadata.deCard = JSON.parse(encryptor.decrypt(row.metadata.card));
          } else {
            row.metadata = {};
            row.metadata.card = row.card
            row.metadata.deCard = JSON.parse(encryptor.decrypt(row.card));
          }

          // if (!row.metadata.deCardnumber)

        })
        this.cards = cards
        // this.isLoading = false
        console.log('card getSecretById', this.cards)
        this.isLoading = false
      }).catch(error => {
        console.log('error', error)
        this.isLoading = false
      })
    },
  }
}
</script>
<style scoped></style>